/* eslint-disable @typescript-eslint/no-explicit-any */
import { loadTag } from "./utils";
import axios from "axios";

const adFormInit = () => {
  window.idMask = "";
  // TODO: trasform in get profile
  axios("/KTI/public/api/v1/users/me?locale=it", {
    method: "get",
    withCredentials: true,
  })
    .then((response) => {
      if (response.data.codiceClienteMask) {
        window.idMask = response.data.codiceClienteMask;
      }
      loadTag({ name: "adform-init" });
    })
    .catch(() => {
      //  TODO: track error in case the user is logged in
      loadTag({ name: "adform-init" });
    });
};

export default adFormInit;
